import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { BasicBlock } from '../../../components/BasicBlock';
import { createBlock, t } from '../../../utils';
import { TableColumn } from '../TableColumn';

export type ITableRow = IBlockData<
    {
        content?: string;
        'bgcolor'?: string;
    },
    {}
>;

export const TableRow = createBlock<ITableRow>({
    get name() {
        return t('Table Row');
    },
    type: BasicType.TABLE_ROW,
    create: (payload: any) => {
        const defaultData: ITableRow = {
            type: BasicType.TABLE_ROW,
            data: {
                value: {
                    content: '',
                },
            },
            attributes: {},
            children: [
                TableColumn.create({}),],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.TABLE],
    render(params: any) {
        const attributes = params.data.attributes;
        return (
            <BasicBlock
                params={params}
                tag='tr'
            />
        );
    },
});
